export default __webpack_public_path__ + "static/media/index-card.51da9928.svg";